import { type ComponentProps } from 'react';

import useMediaLibrarySearchResult from '~modules/media-library/context/useMediaLibrarySearchResult';
import useMediaLibraryUserPreferences from '~modules/media-library/context/useMediaLibraryUserPreferences';
import { ResultList } from '~modules/media-library/view/ResultList/ResultList';

type Props = Pick<ComponentProps<typeof ResultList>, 'AssetActions'>;

export default function ResultListController({ AssetActions }: Props) {
  const { viewVariant } = useMediaLibraryUserPreferences();
  const { resultAssetIds, resultCount, onLoadMore } = useMediaLibrarySearchResult();

  if (!Boolean(resultAssetIds)) return null;

  return (
    <ResultList
      assetIds={resultAssetIds}
      assetCount={resultCount}
      onLoadMore={onLoadMore}
      viewVariant={viewVariant}
      AssetActions={AssetActions}
    />
  );
}
